// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"101":"bc428f0b44882520d7d5","521":"8d980a5fb545e3aa2b18","634":"fac360a52c7755aee49f","794":"1d3d7d9b6adba7202a52"}[chunkId] + ".js";
};